// extracted by mini-css-extract-plugin
export default {"banner":"SelectAllBanner_banner__r77Xh"};